/**
 * Добавляет временную метку к URL изображения для предотвращения кеширования
 * @param imageUrl - URL изображения
 * @param timestamp - временная метка (по умолчанию - текущее время)
 * @returns URL изображения с временной меткой
 */
export const getUncachedImageUrl = (imageUrl: string, timestamp?: number): string => {
  if (!imageUrl) return '';
  
  try {
    const url = new URL(imageUrl, window.location.origin);
    url.searchParams.set('_t', (timestamp || Date.now()).toString());
    return url.toString();
  } catch (error) {
    const separator = imageUrl.includes('?') ? '&' : '?';
    return `${imageUrl}${separator}_t=${timestamp || Date.now()}`;
  }
}; 